
export default function(o, initQuery, onQueryChange){

  var start = function(){

    if(initQuery){
      inputDiv.val(initQuery)
    }

    inputDiv.focus()

  }

  var search = function(){
    console.log('search')
    onQueryChange(inputDiv.val().toLowerCase())

  }

  var searchPlaceholderLabel =
    o.util.getTranslation(o, 'searchPlaceholder')

  var inputDiv =
    o.component.input(o)
    .css({
      flex: '1 1 auto',
      textTransform: 'uppercase',
      zIndex: 1,
      width: '100%',
      maxWidth: '24rem',
    })
    .attr({
      placeholder: searchPlaceholderLabel,
    })

  // inputDiv.on('input', _.throttle(search, 1500, {leading: false, trailing: true}))

  var typingTimer
  var doneTypingInterval = 3000

  inputDiv.on('keyup', function(e){
    if (e.keyCode !== 13 || e.which !== 13) {
      clearTimeout(typingTimer)
      typingTimer = setTimeout(search, doneTypingInterval)
    }
  })

  inputDiv.on('keydown',function(e){
    console.log(e.which)
    if (e.keyCode === 13 || e.which === 13) {
      search()
      clearTimeout(typingTimer)
    } else {
      clearTimeout(typingTimer)
    }
  })

  var div =
    $('<div>')
    .css({
      textAlign: 'center',
    })
    .append([
      inputDiv,
    ])

  div.start = start
  div.input = inputDiv

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/archive/search/search.js